<template>
    <div class="pb-lg-0 mb-5">
        <st-button
            id="st_login_google"
            :block="true"
            variant="danger"
            :callback="loginWithGoogle"
            customClass="font-size-h4 auth-btn-custom"
        >
            <div class="button-content">
                <b-icon-google class="google-icon"></b-icon-google>
                <span class="button-text">{{ buttonText }}</span>
            </div>
        </st-button>
    </div>
</template>
<script>
    import { mapActions } from 'vuex';
    import { AUTH_GOOGLE, GET_GOOGLE_LOGIN_URL, GET_PROFILE } from '../auth-store';
    import { BIconGoogle } from 'bootstrap-vue';

    export default {
        name: 'GoogleLoginButton',
        components: {
            BIconGoogle,
        },
        props: {
            formType: {
                type: String,
                required: true
            }
        },
        computed: {
            buttonText() {
                return this.formType === 'register'
                    ? this.$t('AUTH.REGISTER.GOOGLE_BUTTON')
                    : this.$t('AUTH.LOGIN.GOOGLE_BUTTON');
            }
        },
        methods: {
            ...mapActions({
               authGoogle: `auth/${AUTH_GOOGLE}`,
               getGoogleUrl: `auth/${GET_GOOGLE_LOGIN_URL}`,
               getProfile: `auth/${GET_PROFILE}`
            }),
            loginWithGoogle() {
                this.getGoogleUrl().then((url) => {
                    document.location.href = url;
                });
            },
            signInCallback(authResult) {
                this.authGoogle(authResult['code']).then((data) => {
                    const { isPhoneConfirmed } = data;
                    if (!isPhoneConfirmed) {
                        this.$router.push({ name: 'verifySMS' });
                    } else {
                        this.getProfile().then(() => {
                            this.$router.push({ name: 'home' });
                        });
                    }
                });
            },
        }
    };
</script>
<style scoped lang="scss">
    .auth-btn-custom {
        border-radius: 12px;
        height: 55px;
    }

    .button-content {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
    }

    .google-icon {
        position: absolute;
        left: 0;
        width: 1.8em;
        height: 1.8em;
        padding: 0.25rem;
    }

    .button-text {
        flex: 1;
        padding-left: 3em;
    }
</style>
